import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '欢迎页', icon: 'el-icon-s-home' }
      },
      {
        path: 'order/list',
        name: 'OrderList',
        component: () => import('@/views/order/list.vue'),
        meta: { title: '订单列表', icon: 'el-icon-s-order' }
      },
      {
        path: 'after-sale/list',
        name: 'AfterSaleList',
        component: () => import('@/views/after-sale/list.vue'),
        meta: { title: '售后列表', icon: 'el-icon-service' }
      },
      {
        path: 'product/list',
        name: 'ProductList',
        component: () => import('@/views/product/list.vue'),
        meta: { title: '在售商品列表', icon: 'el-icon-goods' }
      },
      {
        path: 'product/nolist',
        name: 'ProductNolist',
        component: () => import('@/views/product/list.vue'),
        meta: { title: '待售商品列表', icon: 'el-icon-goods' }
      },
      {
        path: 'product/arealimit',
        name: 'ProductAreaLimit',
        component: () => import('@/views/product/arealimit.vue'),
        meta: { title: '区域限制', icon: 'el-icon-location' }
      },
      {
        path: 'product/edit',
        name: 'ProductEdit',
        component: () => import('@/views/product/edit.vue'),
        meta: { title: '商品编辑', icon: 'el-icon-goods' }
      },
      {
        path: 'system/setting',
        name: 'SystemSetting',
        component: () => import('@/views/system/setting.vue'),
        meta: { title: '修改密码', icon: 'el-icon-setting' }
      },
      {
        path: 'system/user',
        name: 'SystemUser',
        component: () => import('@/views/system/user.vue'),
        meta: { title: '用户管理', icon: 'el-icon-user' }
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

// 解决 NavigationDuplicated 报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = store.state.user.token
  if (to.path === '/login') {
    next()
  } else {
    if (token) {
      next()
    } else {
      next('/login')
    }
  }
})

export default router